import { render, staticRenderFns } from "./RunStatus.vue?vue&type=template&id=67f90edb&lang=pug"
import script from "./RunStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./RunStatus.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports